import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './css/ResetPassword.css'; // Create this if needed

const API_BASE = '';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const validateSecurePassword = (password) =>
    /^(?=.*[A-Z])(?=.*\d).{8,}$/.test(password);

  const handleResetPassword = async () => {
    setMessage('');
    setError('');

    if (!validateSecurePassword(newPassword)) {
      setError('Password must be at least 8 characters, include one number and one capital letter.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage('Passwords do not match.');
      return;
    }

    try {
      await axios.post(`${API_BASE}/api/reset-password`, {
        token,
        newPassword,
      });

      setMessage('✅ Password reset successful. Redirecting to login...');
      setTimeout(() => navigate('/'), 2500);
    } catch (error) {
      console.error('Error resetting password:', error);
      const msg = error.response?.data?.message || 'Error resetting password.';
      setMessage(`❌ ${msg}`);
    }
  };

  return (
    <div className="reset-password-container">
      <div className="reset-password-box">
        <h2>Reset Your Password</h2>
        <input
          type="password"
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <input
          type="password"
          placeholder="Confirm New Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        <button onClick={handleResetPassword}>Reset Password</button>
        {error && <p className="error-message">{error}</p>}
        {message && <p className="message">{message}</p>}
      </div>
    </div>
  );
};

export default ResetPassword;

